import { AdvertisementPage, AdvertisementSlot } from '../adConstants';

// Simplified skeleton section templates per page, used only to draw the live
// preview mockups. These are NOT selectable options (those always come from
// the live /registry endpoint) — purely a visual approximation of the real
// page structure in RAK.StoreNext (HomeContent.tsx) / RAK.Mobile (home_screen.dart)
// so the admin can see roughly where an ad slot sits.
//
// Each section may declare `slot` (the ad replaces/sits at this block, used
// for the Home hero/"Top" slot), `afterSlot` (ad renders right after this
// block) or `beforeSlot` (ad renders right before this block).

export function getWebSections(page) {
  switch (page) {
    case AdvertisementPage.Home:
      return [
        { id: 'hero', en: 'Hero Banner', ar: 'البانر الرئيسي', slot: AdvertisementSlot.Top, tall: true },
        { id: 'new-arrivals', en: 'New Arrivals', ar: 'وصل حديثاً', afterSlot: AdvertisementSlot.BelowNewArrivals },
        { id: 'gift-sets', en: 'Gift Sets', ar: 'أطقم وهدايا', afterSlot: AdvertisementSlot.BelowGiftSets },
        { id: 'men', en: "Men's Perfumes", ar: 'عطور الرجال', afterSlot: AdvertisementSlot.BelowMenSection },
        { id: 'women', en: "Women's Perfumes", ar: 'عطور النساء', afterSlot: AdvertisementSlot.BelowWomenSection },
        { id: 'designer', en: 'Designer Perfumes', ar: 'العطور التجارية', afterSlot: AdvertisementSlot.BelowDesignerSection },
        { id: 'niche', en: 'Niche Perfumes', ar: 'العطور المتخصصة', afterSlot: AdvertisementSlot.BelowNicheSection },
        { id: 'bestsellers', en: 'Best Sellers', ar: 'الأكثر مبيعاً', afterSlot: AdvertisementSlot.BelowBestSellers },
        { id: 'brands', en: 'Shop by Brand', ar: 'تسوق حسب الماركة', afterSlot: AdvertisementSlot.BelowBrandsSection },
        { id: 'bottom-spacer', en: '', ar: '', afterSlot: AdvertisementSlot.BottomOfPage, spacer: true },
      ];
    case AdvertisementPage.Product:
      return [
        { id: 'gallery', en: 'Image Gallery', ar: 'معرض الصور', afterSlot: AdvertisementSlot.BelowGallery, tall: true },
        { id: 'info', en: 'Product Info', ar: 'معلومات المنتج', afterSlot: AdvertisementSlot.BelowProductInfo },
        { id: 'description', en: 'Description', ar: 'الوصف', afterSlot: AdvertisementSlot.BelowDescription },
        { id: 'related', en: 'Related Products / Comments', ar: 'منتجات ذات صلة والتعليقات', beforeSlot: AdvertisementSlot.AboveRelatedContent },
      ];
    case AdvertisementPage.Catalog:
      return [
        { id: 'filters', en: 'Filters & Sort', ar: 'الفلاتر والترتيب', beforeSlot: AdvertisementSlot.AboveProducts },
        { id: 'products', en: 'Products Grid', ar: 'شبكة المنتجات', afterSlot: AdvertisementSlot.BelowProducts, tall: true },
      ];
    case AdvertisementPage.Cart:
      return [{ id: 'cart', en: 'Cart Items', ar: 'عناصر السلة', beforeSlot: AdvertisementSlot.Top, tall: true }];
    case AdvertisementPage.Checkout:
      return [{ id: 'checkout', en: 'Checkout Form', ar: 'نموذج الدفع', beforeSlot: AdvertisementSlot.Top, tall: true }];
    case AdvertisementPage.Account:
      return [{ id: 'account', en: 'Account / Orders', ar: 'الحساب والطلبات', beforeSlot: AdvertisementSlot.Top, tall: true }];
    default:
      return [{ id: 'content', en: 'Page Content', ar: 'محتوى الصفحة', beforeSlot: AdvertisementSlot.Top, tall: true }];
  }
}

export function getMobileSections(page) {
  switch (page) {
    case AdvertisementPage.Home:
      return [
        { id: 'hero', en: 'Banner', ar: 'البانر', slot: AdvertisementSlot.Top, tall: true },
        { id: 'new-arrivals', en: 'New Arrivals', ar: 'عطور جديدة', afterSlot: AdvertisementSlot.BelowNewArrivals },
        { id: 'gift-sets', en: 'Gift Sets', ar: 'أطقم وهدايا', afterSlot: AdvertisementSlot.BelowGiftSets },
        { id: 'bestsellers', en: 'Best Sellers', ar: 'الأكثر مبيعاً', afterSlot: AdvertisementSlot.BelowBestSellers },
        { id: 'men', en: "Men's Perfumes", ar: 'عطور الرجال', afterSlot: AdvertisementSlot.BelowMenSection },
        { id: 'women', en: "Women's Perfumes", ar: 'عطور النساء', afterSlot: AdvertisementSlot.BelowWomenSection },
        { id: 'brands', en: 'Brands', ar: 'الماركات', afterSlot: AdvertisementSlot.BelowBrandsSection },
        { id: 'bottom-spacer', en: '', ar: '', afterSlot: AdvertisementSlot.BottomOfPage, spacer: true },
      ];
    case AdvertisementPage.Product:
      return [
        { id: 'gallery', en: 'Gallery', ar: 'معرض الصور', afterSlot: AdvertisementSlot.BelowGallery, tall: true },
        { id: 'description', en: 'Description', ar: 'الوصف', afterSlot: AdvertisementSlot.BelowDescription },
        { id: 'related', en: 'Related Products', ar: 'منتجات ذات صلة', beforeSlot: AdvertisementSlot.AboveRelatedContent },
      ];
    case AdvertisementPage.Catalog:
      return [
        { id: 'filters', en: 'Filters', ar: 'الفلاتر', beforeSlot: AdvertisementSlot.AboveProducts },
        { id: 'products', en: 'Products Grid', ar: 'شبكة المنتجات', afterSlot: AdvertisementSlot.BelowProducts, tall: true },
      ];
    case AdvertisementPage.Cart:
      return [{ id: 'cart', en: 'Cart', ar: 'السلة', beforeSlot: AdvertisementSlot.Top, tall: true }];
    case AdvertisementPage.Checkout:
      return [{ id: 'checkout', en: 'Checkout', ar: 'الدفع', beforeSlot: AdvertisementSlot.Top, tall: true }];
    case AdvertisementPage.Account:
      return [{ id: 'account', en: 'Account', ar: 'الحساب', beforeSlot: AdvertisementSlot.Top, tall: true }];
    default:
      return [{ id: 'content', en: 'Page Content', ar: 'محتوى الصفحة', beforeSlot: AdvertisementSlot.Top, tall: true }];
  }
}
